import { useLocation } from 'react-router-dom'

import { ReactComponent as Curve1 } from '../assets/images/curve-1.svg'
import logo from '../assets/images/protiviti-logo.png'
import smartfirmLogo from '../assets/images/smartfirm-logo.png'

const Footer = () => {
  let location = useLocation()

  return (
    <footer className="w-full">
      {location.pathname !== '/' && (
        <Curve1
          preserveAspectRatio={'none'}
          className="[&_path]:fill-skin-fill"
        />
      )}
      <div className="flex items-center justify-between bg-ateneo-blue px-3 py-6 text-white md:px-6 lg:px-16">
        <a href="https://protiviti.com" target="_blank" rel="noreferrer">
          <img className="w-[104px]" src={logo} alt="logo" />
        </a>
        <div className="">
          <span className="text-xs font-bold">POWERED BY</span>
          <img className="w-[104px]" src={smartfirmLogo} alt="Smartfirm logo" />
        </div>
      </div>
    </footer>
  )
}

export default Footer
